import React, {useEffect, useRef, useState} from 'react';
import OtpInput from 'react-otp-input';
import {TextField} from '@mui/material';

export const EnterCode = ({callback, codeError, isResetCode}) => {
    const [code, setCode] = useState('');
    const [otp, setOtp] = useState('');


    useEffect(() => {
        if (otp.length === 6) {
            callback(otp);
        }
    }, [otp])


    // Refs to control each digit input element
    const inputRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
    ];

    useEffect(() => {
        const resetCode = () => {
            inputRefs.forEach(ref => {
                ref.current = '';
            });
            // inputRefs[0].current.focus();
            setCode('');
            setOtp('');
        }
        resetCode()
    }, [isResetCode])
    // Reset all inputs and clear state


    useEffect(() => {
        callback(code)
    }, [code]);

    // Handle input
    function handleInput(e, index) {
        const input = e.target;
        const previousInput = inputRefs[index - 1];
        const nextInput = inputRefs[index + 1];

        // Update code state with single digit
        const newCode = [...code];
        // Convert lowercase letters to uppercase
        if (/^[0-9]+$/.test(input.value)) {
            const uc = input.value.toUpperCase();
            newCode[index] = uc;
            inputRefs[index].current.value = uc;
        } else {
            newCode[index] = input.value;
        }
        setCode(newCode.join(''));

        input.select();

        if (input.value === '') {
            // If the value is deleted, select previous input, if exists
            if (previousInput) {
                previousInput.current.focus();
            }
        } else if (nextInput) {
            // Select next input on entry, if exists
            nextInput.current.select();
        }
    }

    // Select the contents on focus
    function handleFocus(e) {
        e.target.select();
    }

    // Handle backspace key
    function handleKeyDown(e, index) {
        const input = e.target;
        const previousInput = inputRefs[index - 1];

        if ((e.keyCode === 8 || e.keyCode === 46) && input.value === '') {
            e.preventDefault();
            setCode((prevCode) => prevCode.slice(0, index) + prevCode.slice(index + 1));
            if (previousInput) {
                previousInput.current.focus();
            }
        }
    }

    // Capture pasted characters
    const handlePaste = (e) => {
        const pastedCode = e.clipboardData.getData('text');
        if (pastedCode.length === 6) {
            setCode(pastedCode);
            inputRefs.forEach((inputRef, index) => {
                inputRef.current.value = pastedCode.charAt(index);
            });
        }
    };

    return (
        <>
            <OtpInput

                value={otp}
                onChange={(value) => {
                    setOtp(value);
                    callback(value);
                }}
                numInputs={6}
                inputType='number'
                inputStyle={{width: "38px"}}
                containerStyle={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    direction: "ltr"
                }}

                renderSeparator={<span style={{margin: '0 5px'}}></span>}
                renderInput={(props) => <TextField inputProps={{...props}} sx={{borderRadius: "5px"}}
                                                   fullWidth/>}
                shouldAutoFocus={true}

            />
        </>
        // <div className="d-flex " style={{'direction': 'ltr'}}>
        //     {[0, 1, 2, 3, 4, 5].map((index) => (
        //         <input
        //             className={`form-control mx-2 otp-input ${codeError ? 'border-danger' : ''}`}
        //             key={index}
        //             type="text"
        //             maxLength={1}
        //             onChange={(e) => handleInput(e, index)}
        //             ref={inputRefs[index]}
        //             autoFocus={index === 0}
        //             onFocus={handleFocus}
        //             onKeyDown={(e) => handleKeyDown(e, index)}
        //             onPaste={handlePaste}
        //             disabled={isLoading}
        //         />
        //     ))}
        // </div>
    );
}